import http from "./http-common";
class ArtikelDataService {
  //https://tjsl-backend-local.kai.id/api/get-data-artikel?limit=2
  getAll(offset, limit) {
    return http.get(`/get-data-artikel?offset=${offset}&limit=${limit}`);
  }

  getAllPopuler(offset, limit) {
    return http.get(`/get-data-artikel?offset=${offset}&limit=${limit}&populer=true`);
  }
//   get(id) {
//     return http.get(`/tutorials/${id}`);
//   }
  findById(id) {
    return http.get(`/get-data-artikel-by?id=${id}`);
  }

  sendUserAgent(content_id, category, country_name, country_code, city, state, latitude, longitude, IPv4){
    const formData = { 
      content_id: content_id,
      category: category,
      country_name: country_name,
      country_code: country_code,
      city: city,
      state: state,
      latitude: latitude,
      longitude: longitude,
      IPv4: IPv4,
     };
     return http.post("/add-visitor", formData);
  }
}
export default new ArtikelDataService();